import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';


function AddPerfil({ onNewPerfil, editPerfil }) {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [nombrePerfil, setNombrePerfil] = useState('');
    const [estado, setEstado] = useState(true);
    const { user } = useUser();
    const [modificacion, setModificacion] = useState(1); // Nuevo estado para manejar la modificación

    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
        return fechaISO;
    }

    const fechaFormateada = obtenerFechaISOsinZ();

    useEffect(() => {
        if (editPerfil) {
            setNombrePerfil(editPerfil.nombreperfil);
            setEstado(editPerfil.estado);
            setModificacion(2);
        } else {
            setNombrePerfil('');
            setEstado(true);
            setModificacion(1);
        }
    }, [editPerfil]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const perfil = {
            nombrePerfil,
            estado,
            ingresadoPor: user ? user.codigoUsuario : 'Desconocido',
            fechaIngreso: fechaFormateada
        };

        try {
            const response = await fetch(`${server}/sg_perfile`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(perfil),
            });

            if (response.ok) {
                setNombrePerfil('');
                setEstado(true); // Reiniciar el checkbox a su valor inicial
                alert('Perfil cargado con éxito');
                onNewPerfil();
            } else {
                alert('Error al agregar el perfil');
            }
        } catch (error) {
            console.error('Error al agregar el perfil:', error);
            alert('Error al agregar el perfil');
        }
    };

    return (
        <>
            <h2>{modificacion === 2 ? 'Editar Perfil' : 'Agregar Nuevo Perfil'}</h2>
            <br />
            <form id="Perfiles" data-parsley-validate className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="nombrePerfil">
                        Nombre Perfil: <span className="required">*</span>
                    </label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="nombrePerfil"
                            required="required"
                            className="form-control"
                            value={nombrePerfil}
                            onChange={(e) => setNombrePerfil(e.target.value)}
                        />
                    </div>
                </div>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align">
                        Estado:
                    </label>
                    <div className="col-md-1 col-sm-6">
                        <input
                            type="checkbox"
                            id="estado"
                            checked={estado}
                            onChange={(e) => setEstado(e.target.checked)}
                        /> Activo
                    </div>
                </div>
                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button className="btn btn-primary" type="reset">Limpiar</button>
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Perfil Seguridad')}>Guardar</button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddPerfil;
